import type { FormikHelpers } from 'formik';
import type { WarehouseNameConfig, WarehouseNameMode } from './configs';

type TranslateFn = (key: string) => string;
type ShowToastFn = (message: string, type: 'success' | 'danger') => void;

export type WarehouseNameFormValues = {
    name: string;
};

export interface SubmitWarehouseNameParams {
    mode: WarehouseNameMode;
    entityId?: number | null;
    config: WarehouseNameConfig;
    t: TranslateFn;
    showToast: ShowToastFn;
    setShow: (show: boolean) => void;
    onSuccess: () => Promise<void>;
}

export const submitWarehouseName = async (
    values: WarehouseNameFormValues,
    helpers: FormikHelpers<WarehouseNameFormValues>,
    params: SubmitWarehouseNameParams,
): Promise<void> => {
    const { mode, entityId, config, t, showToast, setShow, onSuccess } = params;
    const { resetForm, setFieldError } = helpers;

    if (mode === 'rename' && !entityId) return;

    const res = await config.submitApi(values.name, entityId);
    if (res?.stat) {
        await onSuccess();
        if (mode === 'create') resetForm();
        setShow(false);
        showToast(t(config.successKey), 'success');
        return;
    }

    if (res?.errCode === 'DUPLICATE_NAME') {
        setFieldError('name', t(config.duplicateKey));
        return;
    }

    if (res?.errCode === 'EMPTY_NAME') {
        setFieldError('name', t(config.emptyKey));
        return;
    }

    showToast(t('common:messError'), 'danger');
};
